import { RefObject, useCallback, useEffect } from 'react'

export const useIframeTouchOutsideUnLock = (
  iframeRef: RefObject<HTMLIFrameElement | null>,
  setScrollLock?: (isLocked: boolean) => void,
) => {
  const handleTouch = useCallback(
    (event: TouchEvent) => {
      if (iframeRef.current && iframeRef.current.contains(event.target as Node)) {
        return
      }

      setScrollLock?.(false)
    },
    [iframeRef, setScrollLock],
  )

  useEffect(() => {
    document.addEventListener('touchstart', handleTouch, { passive: true })

    return () => {
      document.removeEventListener('touchstart', handleTouch)
    }
  }, [handleTouch])
}
